<template>
  <div>
    <div class="panel-header panel-header-custom bg-primary-gradient">
      <div class="page-inner py-5">
        <div
          class="d-flex align-items-left align-items-md-center flex-column flex-md-row"
        >
          <div>
            <h2 class="text-white pb-2 fw-bold">
              {{ $t(titles[$route.params.filter]) }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="page-inner mt--5">
      <!-- Назначение экзамена / Выставить оценки экзамена
      <v-row
        v-if="
          $route.params.filter == 'examAppoint' ||
          $route.params.filter == 'examGrades'
        "
        :style="checkedList.length == 0 && 'visibility: hidden;'"
      >
        <v-col class="shrink mb-5" v-if="$route.params.filter == 'examAppoint'">
          <v-btn
            color="success"
            rounded
            @click="scheduleExam"
            :loading="examActionIsLoading"
            >{{ $t('Назначить экзамен') }}</v-btn
          >
        </v-col>
        <v-col
          class="shrink mb-5"
          v-else-if="$route.params.filter == 'examGrades'"
        >
          <v-btn
            color="success"
            rounded
            @click="putExamGrades"
            :loading="examActionIsLoading"
            >{{ $t('Выставить оценки') }}</v-btn
          >
        </v-col>
      </v-row>
      -->
      <v-data-table
        :headers="headers"
        :items="orderRequestsList"
        item-key="_uid"
        :loading="isLoading"
        hide-default-header
        :options.sync="pagination"
        :footer-props="{'items-per-page-options': [15, 30, 50, 100]}"
        :server-items-length="totalItems"
        class="elevation-1 place-list"
      >
        <template v-slot:header="{props}">
          <thead>
            <tr>
              <th v-for="h in props.headers" :key="h.value">
                <div v-if="h.value === 'iin'">
                  <v-text-field
                    v-model="filters.iin"
                    :label="$t('ИИН')"
                    dense
                    hide-details
                    @input="onSearch"
                  />
                </div>

                <div v-else-if="h.value === 'education_type'">
                  <v-select
                    v-model="filters.education_type"
                    :items="educationList"
                    :label="$t('Тип образования')"
                    dense
                    hide-details
                    @change="onSearch"
                  />
                </div>

                <div v-else-if="h.value === 'payment_type'">
                  <v-select
                    v-model="filters.payment_type"
                    :items="paymentList"
                    :label="$t('Тип оплаты')"
                    dense
                    hide-details
                    @change="onSearch"
                  />
                </div>

                <div v-else>
                  {{ $t(h.text) }}
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item.payment_type="{ item }">
          {{ translateMetadataLabel('payment_type', item.payment_type) }}
        </template>

        <template v-slot:item.education_type="{ item }">
          {{ translateMetadataLabel('education_type', item.education_type) }}
        </template>

        <template v-slot:item.status="{ item }">
          {{ translateMetadataLabel('status', item.status) }}
        </template>

        <template v-slot:item.quota="{ item }">
          {{ translateMetadataLabel('quota_type', item.quota) || $t(item.quota) }}
        </template>

        <template v-slot:item.created_at="{item}">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:item.actions="{item}">
          <v-tooltip left>
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on">
                <router-link
                  :to="`/college/request/${item.id}`"
                  target="_blank"
                  style="text-decoration: none"
                >
                  <v-icon>mdi-open-in-new</v-icon>
                </router-link>
              </span>
            </template>

            <span>{{ $t('Открыть в новом окне') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>

    <!-- Назначение экзамена / Выставить оценки экзамена
    <v-dialog
      v-if="
        $route.params.filter == 'examAppoint' && examScheduleDataList.length
      "
      v-model="examAppointDialog"
      width="950"
      :persistent="examActionIsLoading"
    >
      <v-card>
        <v-card-title class="headline lighten-2">{{
          $t('Назначить экзамен')
        }}</v-card-title>
        <v-card-text>
          <h3 class="black--text">
            {{
              specialtyList.filter((item) => item.code == specialtySelected)[0]
                .name
            }}
          </h3>

          <v-divider></v-divider>
          <v-form class="form" ref="examForm">
            <v-row
              v-for="(item, index) in examScheduleDataList[0]"
              :key="item.id || index"
            >
              <v-col cols="12" class="pb-0">
                <label
                  ><b>{{ item.exam_name }}</b></label
                >
              </v-col>

              <v-col cols="2" class="pb-0">
                <v-menu
                  ref="dateMenu"
                  v-model="item.examDateDialog"
                  :close-on-content-click="false"
                  :return-value.sync="item.examDate"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{on, attrs}">
                    <v-text-field
                      v-model="item.examDate"
                      :label="$t('Дата')"
                      :disabled="!!item.request_exam_id"
                      readonly
                      :rules="[
                        (v) =>
                          (!!v && v.trim().length > 0) ||
                          $t('Обязательное поле'),
                      ]"
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-if="item.examDateDialog"
                    v-model="item.examDate"
                    @click:date="$refs.dateMenu[index].save(item.examDate)"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="2" class="pb-0">
                <v-menu
                  ref="timeMenu"
                  v-model="item.examTimeDialog"
                  :close-on-content-click="false"
                  :return-value.sync="item.examTime"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{on, attrs}">
                    <v-text-field
                      v-model="item.examTime"
                      :label="$t('Время')"
                      :disabled="!!item.request_exam_id"
                      readonly
                      :rules="[
                        (v) =>
                          (!!v && v.trim().length > 0) ||
                          $t('Обязательное поле'),
                      ]"
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    v-if="item.examTimeDialog"
                    v-model="item.examTime"
                    format="24hr"
                    @click:minute="$refs.timeMenu[index].save(item.examTime)"
                  ></v-time-picker>
                </v-menu>
              </v-col>

              <v-col class="pb-0">
                <v-text-field
                  v-model="item.exam_address"
                  :disabled="!!item.request_exam_id"
                  :label="$t('Адрес')"
                  :rules="[
                    (v) =>
                      (!!v && v.trim().length > 0) || $t('Обязательное поле'),
                  ]"
                  type="text"
                ></v-text-field>
              </v-col>

              <v-col class="pb-0" cols="2" v-if="!!item.request_exam_id">
                <v-select
                  v-model="item.localMark"
                  :items="examMarks.filter((el) => el.type == item.grade_type)"
                  item-text="name"
                  :disabled="!!item.mark"
                  item-value="id"
                  :label="$t('Оценка')"
                >
                </v-select>
              </v-col>

              <v-col cols="12" class="pt-0">
                <v-divider class="my-6"></v-divider>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click.stop="scheduleExamSubmit"
            :loading="examActionIsLoading"
          >
            {{ $t('Сохранить') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="$route.params.filter == 'examGrades' && examScheduleDataList.length"
      v-model="examGradesDialog"
      width="970"
      :persistent="examActionIsLoading"
    >
      <v-card>
        <v-card-title class="headline lighten-2">{{
          $t('Выставить оценки')
        }}</v-card-title>
        <v-card-text>
          <h3 class="black--text">
            {{
              specialtyList.filter((item) => item.code == specialtySelected)[0]
                .name
            }}
          </h3>

          <v-divider></v-divider>

          <v-form class="form" ref="examForm">
            <div v-for="(value, index) in checkedList" :key="index">
              <v-row>
                <v-col cols="3">
                  <label
                    ><b>{{ orderRequestsList[value].full_name }}</b></label
                  >
                </v-col>
                <v-col
                  v-for="(item, itemKey) in examScheduleDataList[index]"
                  :key="itemKey"
                >
                  <b>{{ item.exam_name }}</b>
                  <v-select
                    v-model="item.localMark"
                    :items="
                      examMarks.filter((el) => el.type == item.grade_type)
                    "
                    item-text="name"
                    :disabled="!!item.mark"
                    item-value="id"
                    :label="$t('Оценка')"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-divider class="my-3"></v-divider>
            </div>
            <sign-ecp
              @update-ecp-file-data="ecpFileData = $event"
              @update-ecp-password="ecpPassword = $event"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click.stop="examGradesSubmit"
            :loading="examActionIsLoading"
          >
            {{ $t('Сохранить') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->
  </div>
</template>

<script>
import { getMetadataLabel } from '@/utils/metadata'
import { parseOrdersPaginatedResponse } from '@/utils/college'

const FILTER_MAP = {
  new: {
    status: 1,
  },
  accepted: {
    status: 4,
  },
  rejected: {
    status: 2,
  },
  recalled: {
    status: 3,
  },
  work: {
    training_type: 2,
  },
  paid: {
    payment_type: 1,
  },
  exam: {
    status: 5,
  },
  acs: {
    status: 6,
  },
  await: {
    status: 7,
  },
  lose: {
    status: 8
  },
  win: {
    status: 9
  },
}

export default {
  data() {
    return {
      isLoading: false,

      pagination: {
        page: 1,
        itemsPerPage: 15,
      },
      metadata: null,
      orderRequestsList: [],
      totalItems: 0,

      filters: {
        iin: '',
        education_type: '',
        payment_type: null,
      },

      titles: {
        new: 'Новые заявки',
        accepted: 'Принятые',
        rejected: 'Отказанные',
        recalled: 'Отозванные',
        work: 'Рабочие квалификации',
        paid: 'Платное обучение',
        acs: 'Оценки СКБ',
        exam: 'Все экзамены',
        await: 'Ожидающие итогов конкурса',
        lose: 'Не прошедшие конкурс',
        win: 'Прошедшие конкурс',
      },

      headers: [
        {text: 'ИИН', value: 'iin', sortable: false},
        {text: 'ФИО', value: 'fio'},
        {text: 'Квота', value: 'quota'},
        {text: 'Код', value: 'code'},
        {text: 'Тип образования', value: 'education_type', sortable: false},
        {text: 'Тип оплаты', value: 'payment_type', sortable: false},
        {text: 'Статус', value: 'status'},
        {text: 'Дата', value: 'created_at'},
        {text: '', value: 'actions', sortable: false},
      ],
    }
  },

  async mounted() {
    await this.loadMetadata()

    await this.loadOrders()
  },

  methods: {
    onSearch() {
      clearTimeout(this._searchTimer)

      this._searchTimer = setTimeout(() => {
        this.pagination.page = 1
        this.loadOrders()
      }, 500)
    },

    async loadMetadata() {
      this.isLoading = true

      try {
        const {data} = await this.$http.get('/metadata')

        this.metadata = data
      } catch (e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },

    async loadOrders() {
      this.isLoading = true

      try {
        // const filter = this.$route.params.filter

        const params = {
          page: this.pagination.page,
          count: this.pagination.itemsPerPage,
          iin: this.filters.iin || null,
          education_type: this.filters.education_type || null,
          payment_type: this.filters.payment_type || null,
          ...FILTER_MAP[this.$route.params.filter],
        }

        const {data} = await this.$http.get('/orders', {
          params,
        })

        const parsed = parseOrdersPaginatedResponse(data)

        this.orderRequestsList = parsed.items.map((item, index) => ({
          ...item,
          _uid: `${item.id}-${item.code || index}`,
        }))

        this.totalItems = parsed.total
      } catch (e) {
        console.error(e)
        this.orderRequestsList = []
        this.totalItems = 0
      } finally {
        this.isLoading = false
      }
    },

    formatDate(dateString) {
      return new Intl.DateTimeFormat('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(dateString))
    },

    translateMetadataLabel(metadataKey, value) {
      if (value == null || value === '') {
        return ''
      }

      let label = value
      const meta = this.metadata && this.metadata[metadataKey]

      if (meta) {
        const fromMeta = getMetadataLabel(meta, value)
        if (fromMeta) {
          label = fromMeta
        }
      }

      return this.$t(String(label))
    },
  },

  computed: {
    educationList() {
      if (!this.metadata?.education_type) return []

      return Object.entries(this.metadata.education_type).map(
        ([key, label]) => ({
          text: this.$t(label),
          value: Number(key),
        }),
      )
    },

    paymentList() {
      if (!this.metadata?.payment_type) return []

      return Object.entries(this.metadata.payment_type).map(([key, label]) => ({
        text: this.$t(label),
        value: Number(key),
      }))
    },
  },

  watch: {
    pagination: {
      handler(newValue, oldValue) {
        if (!oldValue) {
          return;
        }
        this.loadOrders();
      },
      deep: true,
    },
    '$route.params.filter'() {
      this.pagination.page = 1
      this.loadOrders()
    },
  },
}
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

th label,
th input,
th .v-input {
  font-size: 12px !important;
  font-weight: 700;
}
</style>
